import StructureCell from './StructureCell';

export default StructureCell;
